import { Pipe, PipeTransform } from '@angular/core';
import { FlareSchema } from '@common/flare/flare-schema';
import { getFlareAttr } from '@common/flare/prosemirror/transform/node';
import { ProseMirrorNode } from 'prosemirror-model';

/*
 * Creates a title for a node, usually just uses the type of node it is and its text content, if it has classes/id adds them to the title too.
 * has a special case of Top Of The Document, which makes link have the address 'top'
 * has another special case where its a styles node, prints out the 'id + class - textContent'
 * Usage:
 *   node | mcCreateDocumentBucketNodeTitle
 * Example:
 *   {{ {...type: {...name:'paragraph' }, contentType: 'Hello World', attrs: { class: 'Test' }} |  mcCreateDocumentBucketNodeTitle : {...textContent: 'test'} : false }}
 *    returns 'paragraph.Test - Hello World'
*/
@Pipe({
  name: 'mcCreateDocumentBucketNodeTitle'
})

export class CreateDocumentBucketNodeTitlePipe implements PipeTransform {
  constructor() { }

  static schema = new FlareSchema();
  transform(node: ProseMirrorNode, topOfTheDocument: boolean = false, isStyles: boolean = false): string {
    if (topOfTheDocument) {
      return 'Top Of The Document';
    }

    // set id and class strings
    const idAtr = getFlareAttr<string>(node, 'id');
    const classAtr = getFlareAttr<string>(node, 'class');

    const idStr = idAtr ? '#' + idAtr : '';
    const classStr = classAtr ? '.' + classAtr.replace(' ', '.') : '';

    if (node.type.spec.linkBucket === 'bookmark') {
      return node.attrs.name;
    }

    if (isStyles) {
      return idStr + classStr + ' - ' + node.textContent;
    } else {
      return CreateDocumentBucketNodeTitlePipe.schema.getTagDisplayName(node) + idStr + classStr + ' - ' + node.textContent;
    }
  }
}
